import React from 'react'
import PersonnelManagementDetail from '../../cms/personnel-management/PersonnelManagementDetail'

type Props = {}

const ProfileEmployee: React.FC = ({ }: Props) => {
    return (
        <div>
            <PersonnelManagementDetail IS_PROFILE={true} ONLY_VIEW={false} />
        </div>
    )
}

export default ProfileEmployee